import React, { useCallback, useEffect, useState, useRef } from 'react';
import { Form, Button, Checkbox, Row, Input, DatePicker } from 'antd';
import message from '@web-common/components/UI/Message/SiriusMessage';
import { api, apis, getIn18Text } from 'api';
import classnames from 'classnames';
import styles from './contactform.module.scss';
import { CreatePersonalGroup } from '@web-contact/component/EditPersonalOrg/createGroup';
import { ContactActions, useActions, useAppDispatch } from '@web-common/state/createStore';
import { tarnsEntityContact2ContactItem, isEqualPersonalContact } from '@web-common/components/util/contact';
import { contactFormToParams } from '@web-contact/util';
import { getPersonalOrgList } from '@web-contact/_mock_';
import { emailPattern } from '@web-common/utils/constant';
import { PersonaMarkCheckbox } from '../personalMark/markTip';
import SiriusModal from '@web-common/components/UI/Modal/SiriusModal';
import useCreateCallbackForEvent from '@web-common/hooks/useCreateCallbackForEvent';
import InputContextMenu from '@web-common/components/UI/InputContextMenu/InputContextMenu';
import LxInput from '@lingxi-common-component/sirius-ui/Input';
import { refreshContactDataByEmails } from '@web-common/state/reducer/contactReducer';
import { ReactComponent as TongyongJiantouShang } from '@web-common/images/newIcon/tongyong_jiantou_shang.svg';
import { ReactComponent as TongyongJiantouXia } from '@web-common/images/newIcon/tongyong_jiantou_xia1.svg';
import moment from 'moment';
import lodashGet from 'lodash/get';
const eventApi = api.getEventApi();
const contactApi = api.requireLogicalApi(apis.contactApiImpl);
const dataTrackerApi = api.requireLogicalApi(apis.dataTrackerApiImp);
const systemApi = api.getSystemApi();
const accountApi = api.requireLogicalApi(apis.accountApiImpl);
const ContactForm = props => {
    var _a;
    const { from = 'create', onCancel: _oncancel, contactId: propContactId, contact: propContact, onSuccess, onChangeVisible, onChangeTitle, _account = ((_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '', } = props;
    const isFromPersonalOrg = from === 'personalOrgModal';
    const dispatch = useAppDispatch();
    const contactActions = useActions(ContactActions);
    const [form] = Form.useForm();
    const createGroupRef = useRef();
    const [contact, setContact] = useState(propContact);
    const [personalGroupList, setPersonalGroupList] = useState([]);
    const [checkedGroupIds, setCheckedGroupIds] = useState([]);
    const [isCreatingPersonalGroup, setIsCreatingPersonalGroup] = useState(false);
    const [isEdit, setEdit] = useState(from === 'edit');
    const contactNameInputRef = useRef(null);
    const remarkInputRef = useRef(null);
    const [showExtraInfo, setShowExtraInfo] = useState(false);
    const contactPrefInputRef = useRef(null);
    const contactBirthdayInputRef = useRef(null);
    const contactRoleInputRef = useRef(null);
    const contactTitleInputRef = useRef(null);
    const contactOrgInputRef = useRef(null);
    const contactOrgnameInputRef = useRef(null);
    const [submitLoading, setSubmitLoading] = useState(false);
    useEffect(() => {
        if (propContactId) {
            contactApi.doGetContactById(propContactId, _account).then(res => {
                const model = res[0];
                if (model) {
                    setContact(model);
                    const personalList = model === null || model === void 0 ? void 0 : model.contact.personalOrg;
                    setCheckedGroupIds(personalList || []);
                }
            });
        }
    }, [propContactId]);
    const handleSubmit = async () => {
        if (isCreatingPersonalGroup && createGroupRef.current && createGroupRef.current.addBlurCreateLock) {
            createGroupRef.current.addBlurCreateLock();
            await createGroupRef.current.createNewGroup();
        }
        setCheckedGroupIds(ids => {
            submit(ids || []);
            return ids;
        });
    };
    const requestData = async (params, values, accountId) => {
        var _a;
        let promise;
        let successTxt = getIn18Text('XINZENGCHENGGONG');
        let errorTxt = getIn18Text('XINZENGSHIBAI');
        const phoneList = [];
        (_a = params.phoneList) === null || _a === void 0 ? void 0 : _a.forEach(item => {
            const phone = item.trim();
            if (phone) {
                phoneList.push(phone);
            }
        });
        if (accountId) {
            promise = contactApi.doUpdateContact({
                params: Object.assign(Object.assign({}, params), { phoneList, accountId }),
                _account,
            });
            successTxt = getIn18Text('BIANJICHENGGONG');
            errorTxt = getIn18Text('BIANJISHIBAI');
        }
        else {
            promise = contactApi.doInsertContact({
                list: Object.assign(Object.assign({}, params), { phoneList }),
                _account,
            });
        }
        const { success, data, error } = await promise;
        if (success && (data === null || data === void 0 ? void 0 : data.length)) {
            if (params.emailList) {
                const emailNameMap = params.emailList.reduce((res, email) => {
                    res.set(email, params.name || email);
                    return res;
                }, new Map());
                await refreshContactDataByEmails({ [_account]: params.emailList }, emailNameMap);
            }
            const contact = data[0].contact;
            onSuccess && onSuccess(tarnsEntityContact2ContactItem(contact));
            message.success(isEdit ? getIn18Text('BIANJICHENGGONG') : getIn18Text('XINZENGCHENGGONG'));
            eventApi.sendSysEvent({
                eventName: 'sendSelectedContactIdOnContactPage',
                eventData: {
                    id: contact.id,
                },
            });
        }
        else {
            message.error(error || (isEdit ? getIn18Text('BIANJISHIBAI') : getIn18Text('XINZENGSHIBAI')));
            return;
        }
        const contentArr = [];
        if (values.contactName) {
            contentArr.push(getIn18Text('YOUXINGMING'));
        }
        if (values.emailList.length > 1) {
            contentArr.push(getIn18Text('YOUXINGMING'));
        }
        if (values.mobileList.length > 1) {
            contentArr.push(getIn18Text('YOUDIANHUA'));
        }
        if (values.remark) {
            contentArr.push(getIn18Text('YOUBEIZHU'));
        }
        dataTrackerApi.track('pcContact_click_complete_addContactsPage', {
            content: contentArr.join('，'),
            mailDressCount: values.emailList.length,
            phoneNumberCount: values.mobileList.length,
        });
    };
    const submit = useCreateCallbackForEvent(async (ids) => {
        var _a, _b;
        try {
            setSubmitLoading(true);
            const values = await form.validateFields();
            values.personalOrg = ids;
            if (values.birthday && values.birthday.format) {
                values.birthday = values.birthday.valueOf();
            }
            else {
                values.birthday = undefined;
            }
            const params = contactFormToParams(values);
            if (!isEdit && ((_a = params.emailList) === null || _a === void 0 ? void 0 : _a.length) === 1 && params.name) {
                const email = params.emailList[0];
                const data = await contactApi.doGetContactByEmail({ emails: [email], _account, useData: 'db' });
                const modelList = data[email];
                const sameItem = modelList.find(item => isEqualPersonalContact({ name: params.name, email, contactId: contact === null || contact === void 0 ? void 0 : contact.contact.id }, item));
                if (sameItem) {
                    onChangeVisible && onChangeVisible(false);
                    const model = SiriusModal.error({
                        title: getIn18Text('personalContactReplyToastTitle'),
                        content: getIn18Text('personalContactReplyToastContent'),
                        cancelText: getIn18Text('personalContactReplyToastCancelBtn'),
                        okText: getIn18Text('personalContactReplyToastSaveBtn'),
                        maskClosable: false,
                        keyboard: false,
                        closable: true,
                        cancelButtonProps: {
                            onClick: async () => {
                                await requestData(params, values);
                                model.destroy();
                            },
                        },
                        onOk: () => {
                            setContact(sameItem);
                            const personalList = sameItem === null || sameItem === void 0 ? void 0 : sameItem.contact.personalOrg;
                            setCheckedGroupIds(personalList || []);
                            setEdit(true);
                            onChangeTitle && onChangeTitle(getIn18Text('BIANJILIANXIREN'));
                        },
                        afterClose: () => {
                            onChangeVisible && onChangeVisible(true);
                        },
                    });
                    return;
                }
            }
            const accountId = ((_b = contact === null || contact === void 0 ? void 0 : contact.contact) === null || _b === void 0 ? void 0 : _b.type) === 'personal' ? contact === null || contact === void 0 ? void 0 : contact.contact.id : undefined;
            await requestData(params, values, accountId);
        }
        catch (ex) {
            const isValidateError = lodashGet(ex, 'errorFields[0].errors.length', 0);
            let errMsg = lodashGet(ex, 'message', `${ex}`);
            if (isValidateError) {
                errMsg = lodashGet(ex, 'errorFields', [])
                    .flatMap(item => {
                    return item.errors.join(',');
                })
                    .join(';');
            }
            eventApi.sendSysEvent({
                eventName: 'error',
                eventLevel: 'error',
                eventStrData: '',
                eventData: {
                    popupType: 'toast',
                    popupLevel: 'error',
                    title: (from === 'edit' ? '更新联系人失败:' : '新增联系人失败:') + errMsg,
                    code: 'PARAM.ERR',
                },
                eventSeq: 0,
            });
        }
        finally {
            setSubmitLoading(false);
        }
    });
    const onCancel = useCallback(() => {
        if (isCreatingPersonalGroup && createGroupRef.current && createGroupRef.current.addBlurCreateLock) {
            createGroupRef.current.addBlurCreateLock();
        }
        _oncancel();
    }, [isCreatingPersonalGroup]);
    const clearExternal = useCallback(() => {
        contactActions.doCreateFormExternal(undefined);
    }, []);
    useEffect(() => {
        form.setFieldsValue(getInitValues(contact));
    }, [contact, form]);
    useEffect(() => () => {
        clearExternal();
    }, [clearExternal]);
    const renderItemList = params => (fields, { add, remove }) => (React.createElement(React.Fragment, null,
        fields.map((field, index) => {
            const listInputRef = { current: null };
            return (React.createElement(InputContextMenu, { inputOutRef: listInputRef, changeVal: val => {
                    const list = form.getFieldValue(params.name);
                    list[index] = val;
                    form.setFieldsValue({ [params.name]: list });
                } },
                React.createElement(Form.Item, { key: field.key, hidden: params.hidden, label: index === 0 ? params.label : ' ', className: styles.listItem },
                    React.createElement(Form.Item, Object.assign({}, field, { rules: params.rules, validateTrigger: params.validateTrigger, noStyle: true }),
                        React.createElement(LxInput, { maxLength: Number.isSafeInteger(params.maxlength) ? params.maxlength : undefined, ref: listInputRef, placeholder: params.placeholder, "data-test-id": `modal_personal_${params.type}`, openFix: false })),
                    fields.length > 1 ? (React.createElement("i", { className: `dark-invert ${styles.close}`, "data-test-id": `modal_personal_btn_reomve_${params.type}`, onClick: () => {
                            remove(field.name);
                        } })) : null)));
        }),
        React.createElement("span", { className: styles.add, onClick: () => add(''), "data-test-id": `modal_personal_btn_add_${params.type}`, hidden: params.hidden }, params.addText)));
    const togglePersonalGroupCheckbox = (flag, itemId) => {
        setCheckedGroupIds(ids => {
            const idSets = new Set(ids);
            if (flag) {
                idSets.add(itemId);
            }
            else {
                idSets.delete(itemId);
            }
            return [...idSets];
        });
    };
    const createGroupSuccess = (data, isChecked) => {
        isChecked &&
            setCheckedGroupIds(list => {
                const idSets = new Set(list);
                idSets.add(data.id);
                return [...idSets];
            });
        setPersonalGroupList(list => {
            list.push(data);
            return list;
        });
        setIsCreatingPersonalGroup(false);
    };
    const cancelCreateGroup = () => {
        setIsCreatingPersonalGroup(false);
    };
    const addNewPersonalGroup = useCallback(async () => {
        if (isCreatingPersonalGroup && createGroupRef.current && createGroupRef.current.addBlurCreateLock) {
            createGroupRef.current.addBlurCreateLock();
            await createGroupRef.current.createNewGroup();
        }
        setIsCreatingPersonalGroup(true);
    }, [isCreatingPersonalGroup]);
    useEffect(() => {
        if (!isFromPersonalOrg) {
            getPersonalOrgList(_account).then(res => {
                setPersonalGroupList(res.map(item => ({ name: item.orgName, id: item.id })));
            });
        }
    }, [isFromPersonalOrg]);
    return (React.createElement(Form, { form: form, className: classnames(styles.form, {
            [styles.isFromPersonalOrg]: isFromPersonalOrg,
        }), colon: false },
        React.createElement("div", { className: `ant-allow-dark ${styles.content}` },
            React.createElement(InputContextMenu, { inputOutRef: contactNameInputRef, changeVal: val => form.setFieldsValue({ contactName: val }) },
                React.createElement(Form.Item, { required: false, label: getIn18Text('YONGHUXINGMING'), name: "contactName", validateTrigger: ['onChange', 'onBlur'], rules: [
                        { required: true, message: getIn18Text('QINGSHURUYONGHU') },
                        {
                            max: 100,
                            message: getIn18Text('QINGSHURUBUCHAO'),
                        },
                    ] },
                    React.createElement(LxInput, { ref: contactNameInputRef, placeholder: getIn18Text('QINGSHURUYONGHU'), "data-test-id": "modal_personal_name", openFix: false }))),
            React.createElement(Form.List, { name: "emailList" }, renderItemList({
                type: 'account',
                name: 'emailList',
                label: getIn18Text('DIANZIYOUXIANG'),
                addText: getIn18Text('TIANJIAYOUXIANG'),
                placeholder: getIn18Text('QINGSHURUYOUXIANGZHANG'),
                validateTrigger: ['onChange', 'onBlur'],
                normalize: value => value.trim(),
                rules: [
                    {
                        required: !0,
                        message: getIn18Text('QINGSHURUYOUXIANGZHANG'),
                    },
                    {
                        pattern: emailPattern,
                        message: getIn18Text('QINGSHURUZHENGQUE11'),
                    },
                ],
            })),
            React.createElement(Form.Item, { label: "", noStyle: true, name: "isMark" },
                React.createElement(PersonaMarkCheckbox, { testId: "modal_personal_personalMark_checkbox", style: { marginLeft: 80, marginBottom: 16 } })),
            React.createElement(Form.List, { name: "mobileList" }, renderItemList({
                type: 'phone',
                name: 'mobileList',
                label: getIn18Text('DIANHUAHAOMA'),
                addText: getIn18Text('TIANJIAHAOMA'),
                placeholder: getIn18Text('XUANTIAN\uFF0CQINGSHU11'),
            })),
            React.createElement(InputContextMenu, { inputOutRef: remarkInputRef, changeVal: val => form.setFieldsValue({ remark: val }) },
                React.createElement(Form.Item, { label: getIn18Text('BEIZHUXINXI'), name: "remark", rules: [
                        {
                            max: 1000,
                            type: 'string',
                            message: getIn18Text('BEIZHUBUCHAOGUO'),
                        },
                    ] },
                    React.createElement(Input.TextArea, { ref: remarkInputRef, style: { height: 70, resize: 'none' }, placeholder: getIn18Text('XUANTIAN\uFF0CQINGSHU'), "data-test-id": "modal_personal_remark" }))),
            !isFromPersonalOrg && (React.createElement(Form.Item, { label: getIn18Text('XUANZEFENZU'), className: styles.personalOrgWrapper },
                personalGroupList.length > 0 ? (React.createElement("div", { className: styles.personalOrgGroup, "data-test-id": "modal_personal_personalOrg" }, personalGroupList.map(item => {
                    const checked = checkedGroupIds.includes(item.id);
                    return (React.createElement(Row, { key: item.id, className: styles.personalOrgItem, "data-test-id": "modal_personal_personalOrg_item" },
                        React.createElement(Checkbox, { value: item.id, "data-test-id": "modal_personal_personalOrg_item_checkbox", "data-test-check": checked, checked: checked, onChange: e => {
                                togglePersonalGroupCheckbox(e.target.checked, e.target.value);
                            } }, item.name)));
                }))) : null,
                isCreatingPersonalGroup && (React.createElement(Row, { style: { paddingLeft: '12px' } },
                    React.createElement(CreatePersonalGroup, { _account: _account, groupNames: personalGroupList.map(item => item.name), ref: createGroupRef, success: createGroupSuccess, cancel: cancelCreateGroup, customInputClass: styles.newGroupInput }))),
                React.createElement(Row, null,
                    React.createElement("span", { "data-test-id": "modal_personal_btn_addPersonalOrg", className: styles.addPersonalGroupBtn, onMouseDown: addNewPersonalGroup }, getIn18Text('TIANJIAGERENFEN'))))),
            React.createElement(Form.Item, null,
                React.createElement(Row, null,
                    React.createElement("span", { "data-test-id": "modal_personal_btn_extraInfo", onClick: () => {
                            setShowExtraInfo(!showExtraInfo);
                        }, className: styles.showmore },
                        getIn18Text('GENGDUOXUANXIANG'),
                        showExtraInfo ? React.createElement(TongyongJiantouShang, null) : React.createElement(TongyongJiantouXia, null)))),
            React.createElement(Form.List, { name: "adrList" }, renderItemList({
                maxlength: 200,
                type: 'address',
                name: 'adrList',
                normalize: value => value.trim().replace(/;/g, ''),
                label: getIn18Text('LIANXIDIZHI'),
                addText: getIn18Text('TIANJIADIZHI'),
                placeholder: getIn18Text('XUANTIAN') + '，' + getIn18Text('QINGSHURULIANXIDZ'),
                hidden: !showExtraInfo,
            })),
            React.createElement(Form.Item, { label: getIn18Text('SHENGRI'), rules: [], name: "birthday", hidden: !showExtraInfo },
                React.createElement(DatePicker, { dropdownClassName: "modal_personal_birthday", className: styles.birithdayPicker, placeholder: getIn18Text('XUANTIAN') + ',' + getIn18Text('QINGXUANZESHENGRIXX'), format: "YYYY/MM/DD" })),
            React.createElement(Form.Item, { label: getIn18Text('GERENZHUYE'), rules: [], name: "pref", hidden: !showExtraInfo },
                React.createElement(LxInput, { "data-test-id": "modal_personal_pref", ref: contactPrefInputRef, placeholder: getIn18Text('XUANTIAN') + '，' + getIn18Text('QINGSHURUGERENZY'), openFix: false, maxLength: 200 })),
            React.createElement(Form.Item, { label: getIn18Text('GONGSIMINGCHENG'), rules: [], name: "orgname", hidden: !showExtraInfo },
                React.createElement(LxInput, { "data-test-id": "modal_personal_orgname", ref: contactOrgnameInputRef, placeholder: getIn18Text('XUANTIAN') + '，' + getIn18Text('QINGSHURUGONGSIMC'), openFix: false, maxLength: 200 })),
            React.createElement(Form.Item, { label: getIn18Text('BUMENMINGCHENG'), rules: [], name: "org", hidden: !showExtraInfo },
                React.createElement(LxInput, { "data-test-id": "modal_personal_org", ref: contactOrgInputRef, placeholder: getIn18Text('XUANTIAN') + '，' + getIn18Text('QINGSHURUBUMENMC'), openFix: false, maxLength: 200 })),
            React.createElement(Form.Item, { label: getIn18Text('ZHIWEI'), rules: [], name: "title", hidden: !showExtraInfo },
                React.createElement(LxInput, { "data-test-id": "modal_personal_pos", ref: contactTitleInputRef, placeholder: getIn18Text('XUANTIAN') + '，' + getIn18Text('QINGSHURUZHIWEIXX'), openFix: false, maxLength: 200 })),
            React.createElement(Form.Item, { label: getIn18Text('JUESE'), rules: [], name: "role", hidden: !showExtraInfo },
                React.createElement(LxInput, { "data-test-id": "modal_personal_role", ref: contactRoleInputRef, placeholder: getIn18Text('XUANTIAN') + '，' + getIn18Text('QINGSHURUJUESEXX'), openFix: false, maxLength: 200 }))),
        React.createElement("div", { className: styles.footer },
            React.createElement(Button, { "data-test-id": "modal_personal_btn_cancel", type: "default", className: `ant-allow-dark ${styles.cancelBtn}`, onMouseDown: onCancel }, getIn18Text('QUXIAO')),
            React.createElement(Button, { loading: submitLoading, "data-test-id": "modal_personal_btn_save", type: "primary", className: styles.mainBtn, onMouseDown: handleSubmit }, getIn18Text('BAOCUN')))));
};
const getInitValues = (contact) => {
    var _a, _b;
    let initValues = {
        contactName: '',
        emailList: [''],
        mobileList: [''],
        adrList: [''],
        personalOrg: [],
        isMark: false,
    };
    if (contact !== undefined) {
        if (contact.contact.type === 'external') {
            initValues = Object.assign(Object.assign({}, initValues), { contactName: contact.contact.contactName, emailList: [contact.contact.accountName] });
        }
        else if (contact.contact.type === 'personal') {
            const marked = contact.contact.marked || 0;
            const emaillist = new Set([contact.contact.accountName]);
            contact.contactInfo.forEach(item => {
                item.contactItemType === 'EMAIL' && emaillist.add(item.contactItemVal);
            });
            initValues = {
                contactName: contact.contact.contactName,
                emailList: [...emaillist],
                mobileList: contact.contactInfo.filter(e => e.contactItemType === 'MOBILE' || e.contactItemType === 'TEL').map(e => e.contactItemVal),
                remark: contact.contact.remark,
                personalOrg: contact.contact.personalOrg || [],
                isMark: marked > 0,
                adrList: (((_a = contact.contact) === null || _a === void 0 ? void 0 : _a.adrList) || [])
                    .filter(item => {
                    return item && item.trim().length > 0;
                })
                    .map(adr => {
                    return adr.replace(/;/g, '');
                }),
                pref: contact.contact.pref || '',
                birthday: contact.contact.birthday ? moment(contact.contact.birthday) : '',
                role: contact.contact.role || '',
                title: contact.contact.title || '',
                org: contact.contact.org || '',
                orgname: contact.contact.orgname || '',
            };
            if (initValues.emailList.length === 0) {
                initValues.emailList.push('');
            }
            if (initValues.mobileList.length === 0) {
                initValues.mobileList.push('');
            }
            if (((_b = initValues.adrList) === null || _b === void 0 ? void 0 : _b.length) === 0) {
                initValues.adrList.push('');
            }
        }
        else if (['customer', 'clue'].includes(contact.contact.type)) {
            initValues = {
                contactName: contact.contact.contactName || contact.contact.accountName,
                emailList: [contact.contact.accountName],
                mobileList: contact.contactInfo.filter(e => e.contactItemType === 'MOBILE' || e.contactItemType === 'TEL').map(e => e.contactItemVal),
                remark: contact.contact.remark,
                personalOrg: contact.contact.personalOrg || [],
            };
            if (initValues.mobileList.length === 0) {
                initValues.mobileList.push('');
            }
        }
    }
    return initValues;
};
export default ContactForm;
